import { buildModelManager } from "../builder.js";
const DefaultClientTagAssignmentSelection = {
  __typename: true,
  id: true,
  autoSourceField: true,
  clientId: true,
  clientTagId: true,
  createdAt: true,
  deletedAt: true,
  profileId: true,
  source: true,
  updatedAt: true
};
const modelApiIdentifier = "clientTagAssignment";
const pluralModelApiIdentifier = "clientTagAssignments";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClientTagAssignmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClientTagAssignmentSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClientTagAssignmentSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClientTagAssignmentSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClientTagAssignmentSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClientTagAssignmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClientTagAssignmentSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createClientTagAssignment",
    operationReturnType: "CreateClientTagAssignment",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      clientTagAssignment: { required: false, type: "CreateClientTagAssignmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClientTagAssignmentSelection
  },
  {
    type: "action",
    operationName: "bulkCreateClientTagAssignments",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateClientTagAssignmentsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultClientTagAssignmentSelection
  },
  {
    type: "action",
    operationName: "updateClientTagAssignment",
    operationReturnType: "UpdateClientTagAssignment",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      clientTagAssignment: { required: false, type: "UpdateClientTagAssignmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClientTagAssignmentSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateClientTagAssignments",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateClientTagAssignmentsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultClientTagAssignmentSelection
  },
  {
    type: "action",
    operationName: "deleteClientTagAssignment",
    operationReturnType: "DeleteClientTagAssignment",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteClientTagAssignments",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "restoreClientTagAssignment",
    operationReturnType: "RestoreClientTagAssignment",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      clientTagAssignment: { required: false, type: "RestoreClientTagAssignmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClientTagAssignmentSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreClientTagAssignments",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkRestoreClientTagAssignmentsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultClientTagAssignmentSelection
  },
  {
    type: "action",
    operationName: "upsertClientTagAssignment",
    operationReturnType: "UpsertClientTagAssignment",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      clientTagAssignment: { required: false, type: "UpsertClientTagAssignmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateClientTagAssignmentResult": { hasReturnType: false },
      "... on UpdateClientTagAssignmentResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClientTagAssignmentSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertClientTagAssignments",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertClientTagAssignmentsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultClientTagAssignmentSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "clientTagAssignmentGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ClientTagAssignmentManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultClientTagAssignmentSelection,
  operations
);
export {
  ClientTagAssignmentManager,
  DefaultClientTagAssignmentSelection
};
//# sourceMappingURL=ClientTagAssignment.js.map
